import React from 'react';
import './TransitionOverlay.css';

const TransitionOverlay = ({ isVisible }) => {
  return (
    <div className={`transition-overlay ${isVisible ? 'visible' : ''}`} />
  );
};

export default TransitionOverlay;